var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_525_30641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.942139,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_525_30641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9422 13.4L8.04219 18.3C7.85885 18.4833 7.62552 18.575 7.34219 18.575C7.05885 18.575 6.82552 18.4833 6.64219 18.3C6.45885 18.1167 6.36719 17.8833 6.36719 17.6C6.36719 17.3167 6.45885 17.0833 6.64219 16.9L11.5422 12L6.64219 7.09999C6.45885 6.91665 6.36719 6.68332 6.36719 6.39999C6.36719 6.11665 6.45885 5.88332 6.64219 5.69999C6.82552 5.51665 7.05885 5.42499 7.34219 5.42499C7.62552 5.42499 7.85885 5.51665 8.04219 5.69999L12.9422 10.6L17.8422 5.69999C18.0255 5.51665 18.2589 5.42499 18.5422 5.42499C18.8255 5.42499 19.0589 5.51665 19.2422 5.69999C19.4255 5.88332 19.5172 6.11665 19.5172 6.39999C19.5172 6.68332 19.4255 6.91665 19.2422 7.09999L14.3422 12L19.2422 16.9C19.4255 17.0833 19.5172 17.3167 19.5172 17.6C19.5172 17.8833 19.4255 18.1167 19.2422 18.3C19.0589 18.4833 18.8255 18.575 18.5422 18.575C18.2589 18.575 18.0255 18.4833 17.8422 18.3L12.9422 13.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.5d289a10879efdbe2fdad0ed3d8acd0e.svg";
export { ForwardRef as ReactComponent };